import React from 'react';
import logo from './logo.svg';
import './App.css';


import {Hero} from './components/Hero';
import {About} from './components/About';
import {Projects} from './components/Projects';
import {Skills} from './components/Skills';
import {Contact} from './components/Contact';
import {Navigation} from './components/Navigation';
import {Stats} from './components/Stats';
import {Testimonials} from './components/Testimonials';

function App() {
    return (
        <div className="App">
            <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-slate-100">
                <Navigation/>
                <Hero/>
                <Stats/>
                <About/>
                <Skills/>
                <Projects/>
                <Testimonials/>
                <Contact/>
            </div>
        </div>
    )
}

export default App
